module.exports = __webpack_public_path__ + "static/media/24-7.547df329.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/features/24-7.svg
// module id = 131
// module chunks = 0